/*@ngInject*/
const PolicyRewriteActionRepository = function ($q, baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.getPolicyRewriteSummary = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}`;
        return this.get(url);
    };

    this.deletePolicyRewrite = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}`;
        return this.delete(url);
    };

    this.start = function (policyId, isReissue) {
        const url = `/rest/Policy/${policyId}/startRewrite`,
              config = {
                    params: {
                        reissue: isReissue
                    },
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
        return this.post(url, {}, config);
    };

    this.create = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/createPolicyRewrite`;
        return this.post(url);
    };

    this.submit = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/submit`,
            config = {
                params: {
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.startRating = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/startRating`;
        return this.post(url);
    };

    this.refreshQuote = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/refreshQuote`;
        return this.post(url);
    };

    this.submitForIssuance = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/submitForIssuance`,
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.markIssued = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/markAsIssued`,
            config = {
                params: {
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.revertToSubmitted = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/revertToSubmitted`;
        return this.post(url);
    };

    this.generateRating = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/generateRating`;
        return this.post(url);
    };

    this.startPricing = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/startPricing`;
        return this.post(url);
    };

    this.modifyPricing = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/modifyPricing`;
        return this.post(url);
    };

    this.modifyRating = function (policyRewriteId) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/modifyRating`;
        return this.post(url);
    };

    this.generateRatingAttachments = function (policyRewriteId, attachmentsToGenerate) {
        const url = `/rest/PolicyRewrite/${policyRewriteId}/generateRatingAttachments`,
            config = {
                params: {
                    attachmentsToGenerate: attachmentsToGenerate
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('policyRewriteActionRepository', PolicyRewriteActionRepository);
